import { _sportsInfoTypes, useSportsInfo } from "projectSpecific/sports/useHelpers/useSportsInfo";
import React, { useContext, useEffect, useMemo, useReducer, useState } from "react";
import { ParentContext } from '../../../../global/cnr/contexts/ParentContext';
import { _cacheNames, _cacheTypes } from "../../../../global/cnr/reducers/ServiceWorkerReducer";
import { sportsOrganizationHandlers, sportsOrganizationInitialState, sportsOrganizationReducer } from "../reducers/SportsOrganizationReducer";

export const SportsOrganizationContext = React.createContext()

export default function SportsOrganizationProvider(props) {

  const { directReturn } = props ?? {}

  const parentContext = useContext(ParentContext)
  const { states, handlers, fns } = parentContext ?? {}
  const { appUser_state, paps_state, page_state, currentSettings_state, serviceWorker_state } = states ?? {}
  const { serviceWorker_handlers } = handlers ?? {}
  const { database_fns } = fns ?? {}

  const { cache_info } = serviceWorker_state ?? {}
  const { cache_groups } = cache_info ?? {}
  const { cache_organization } = cache_groups ?? {}

  // appUserContext
  const { appUser } = appUser_state ?? {}
  const { uid } = appUser ?? {}

  // papsContext 
  const { pathViews } = paps_state ?? {}
  const { organizations: organizations_key } = pathViews ?? {}
  const view = 'organizations'

  // pageContext 
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { aps_page } = _.get(page_state, 'pageSettings', {});
  const { projectOptions } = aps_global ?? {}
  let { useAppDarkMode } = projectOptions ?? {}

  const { viewItems: viewItems_page } = aps_page ?? {}

  let viewItem = viewItems_page && viewItems_page[view] ? viewItems_page[view] : {}
  const { dataSource } = viewItem ?? {}
  let { dataParents, useSeasonals } = dataSource ?? {}

  if (!dataParents) {
    dataParents = ['orgnaizations', 'districts']
  }

  const _cacheKey = _cacheNames.cache_organization + '-' + organizations_key
  const _cacheData = cache_organization && cache_organization[organizations_key]

  let ownerPath;

  if (pathViews) {
    if (pathViews.schools) { ownerPath = 'schools' }
    if (pathViews.districts) { ownerPath = 'districts' }
    if (pathViews.organizations) { ownerPath = 'organizations' }
  }

  const init_state = {
    useAppDarkMode,
    viewItem,
    useSeasonals,
    uid,
    ownerPath,
    inverted: false,
    cssOpts: { name: 'ssc-normal' },
    _cacheData,
    database_fns
  }

  const [sportsOrganization_state, sportsOrganization_dispatch] = useReducer(sportsOrganizationReducer, init_state, sportsOrganizationInitialState)
  const sportsOrganization_handlers = useMemo(
    () => sportsOrganizationHandlers(sportsOrganization_dispatch),
    [sportsOrganization_dispatch]
  );
  const { organization_data } = sportsOrganization_state ?? {}

  const [organizationInfo, setOrganizationInfo] = useState()

  const { getSportInfoData } = useSportsInfo({ sportsInfoType: _sportsInfoTypes.organizations, existingData: organization_data })

  useEffect(() => {
    getSportInfoData(_sportsInfoTypes.organizations, setOrganizationInfo)
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [pathViews.organizations])

  useEffect(() => {
    if (pathViews.organizations && !_.isEmpty(organizationInfo)) {
      sportsOrganization_handlers.handleSet_organizationInfo(organizationInfo)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [organizationInfo])

  useEffect(() => {
    if (organization_data && !_cacheData) {
      const settings = {
        cacheKey: _cacheKey,
        cacheName: _cacheTypes.organization_data,
        cacheData: organization_data,
      }
      serviceWorker_handlers.handleSend_messageToServiceWorker(settings);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [organization_data])

  if (sportsOrganization_state) {
    if (directReturn) {
      return { sportsOrganization_handlers, sportsOrganization_state }
    } else {
      return <SportsOrganizationContext.Provider
        value={{ sportsOrganization_state, sportsOrganization_handlers, appComponent: 'sportsOrganization' }}>
        {props.children}
      </SportsOrganizationContext.Provider>
    }
  } else {
    return <SportsOrganizationContext.Provider
      value={{}}>
      {props.children}
    </SportsOrganizationContext.Provider>
  }
}